module.exports = __webpack_public_path__ + "img/2022820171947.75cbc206.jpg";